import { apiEnvelope } from '../envelope';
import { surfaceDocumentSchema } from './types';

/**
 * Transport envelope for a served surface document.
 *
 * Two things are called an "envelope" around here and both apply: the ADR-002
 * `{ data, error }` transport envelope wraps the ADR-046 document envelope. The
 * document therefore travels in `data` and is never the top-level body — same
 * shape as `homeSummaryResponseSchema`, so a client can treat a null `data` or a
 * non-null `error` uniformly across both home reads.
 */
export const homeSurfaceResponseSchema = apiEnvelope(surfaceDocumentSchema);
export type HomeSurfaceResponse = ReturnType<typeof homeSurfaceResponseSchema.parse>;
